enum FuelType {
  Diesel = 'diesel',
  Petrol = 'petrol',
  Hybrid = 'pluginHybrid',
  EREV = 'erev',
  Electric = 'el',
  MildHybrid = 'mildHybrid',
}

export default FuelType;
